// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setHours as fn } from "../setHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setHoursWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setHoursWithOptions;
